import createRequest from '../core/request'

/**
 * 批量给名片添加tag
 */
export function patch_card_tag(params, data) {
  return createRequest('TagAPI').post('/edm_patch_card_tag', data, {
    params
  })
}

/**
 * 新增tag（可批量）
 */
export function create_tag(params, data) {
  return createRequest('TagAPI').post('/create_tag_v2', data, {
    params
  })
}

// 获取单张名片的标签
export function query_card_tag(params) {
  return createRequest('TagAPI').get('/query_card_tag_v2', {
    params
  })
}
// 批量为多张名片添加tag (批量)
export function batch_card_tag(params, data) {
  return createRequest('TagAPI').post('/batch_card_tag', data, {
    params
  })
}

// 删除名片标签
export function delete_card_tag(params, data) {
  return createRequest('TagAPI').post('/delete_card_tag_v2', data, {
    params
  })
}

// 单张名片设置标签
export function patch_card_single_tag(params, data) {
  return createRequest('TagAPI').post('/patch_card_tag_v2', data, {
    params
  })
}

// 编辑标签
export function update_tag(params, data) {
  return createRequest('TagAPI').post('/update_tag_v2', data, {
    params
  })
}

// 删除标签
export function remove_tag(params, data) {
  return createRequest('TagAPI').post('/remove_tag_v2', data, {
    params
  })
}
